// Плашка «Рейсы из TMS не поступают» — логика без DOM (решение Анны 02.11.2026).
// Сервер (GET /api/v2/workspace/intake) решает, всё ли в порядке; здесь — когда и как показать.

export const POLL_MS = 120000
export const HIDE_MS = 30 * 60 * 1000
export const HIDE_KEY = 'tmsIntakeBannerHidden'

// Плашку показываем только при настоящем сбое: рейсы не поступают или конкретные рейсы застряли.
// Короткие задержки видны в «Сводке логиста → Состояние системы» и не мешают работе.
export function shouldShow(state) {
  if (!state || typeof state !== 'object') return false
  if (state.state === 'down') return true
  return state.state === 'degraded' && state.reason === 'stuck'
}

export function tone(state) {
  return state && state.state === 'down' ? 'red' : 'amber'
}

export function humanMinutes(total) {
  const m = Math.max(0, Math.round(Number(total) || 0))
  const hours = Math.floor(m / 60)
  const rest = m % 60
  if (hours === 0) return `${rest} мин`
  if (hours >= 48) {
    const days = Math.floor(hours / 24)
    const h = hours % 24
    return h ? `${days} дн. ${h} ч` : `${days} дн.`
  }
  return rest ? `${hours} ч ${rest} мин` : `${hours} ч`
}

function pad(n) {
  return String(n).padStart(2, '0')
}

// «с 17:50 (40 мин)» — по часам компьютера сотрудника; вчерашнее — с датой.
export function sinceText(iso, now = new Date()) {
  if (!iso) return ''
  const at = new Date(iso)
  if (Number.isNaN(at.getTime())) return ''
  const minutes = Math.max(0, Math.floor((now.getTime() - at.getTime()) / 60000))
  const sameDay = at.toDateString() === now.toDateString()
  const clock = `${pad(at.getHours())}:${pad(at.getMinutes())}`
  const when = sameDay ? clock : `${pad(at.getDate())}.${pad(at.getMonth() + 1)} ${clock}`
  return `с ${when} (${humanMinutes(minutes)})`
}

export function stuckLine(item) {
  if (!item) return ''
  const parts = [String(item.number || '—')]
  if (item.reason) parts.push(item.reason)
  return parts.join(' — ') + (item.minutes ? ` · ${humanMinutes(item.minutes)}` : '')
}

// Ключ сбоя: скрытая плашка снова появится, если сбой сменился или стал серьёзнее.
export function incidentKey(state) {
  if (!state) return ''
  return [state.reason || '', state.state || '', state.since || ''].join('|')
}

export function isHidden(saved, state, nowMs = Date.now()) {
  if (!saved || !state) return false
  let value = saved
  if (typeof saved === 'string') {
    try {
      value = JSON.parse(saved)
    } catch (e) {
      return false
    }
  }
  if (!value || value.key !== incidentKey(state)) return false
  return Number(value.until) > nowMs
}

export function hideRecord(state, nowMs = Date.now()) {
  return JSON.stringify({ key: incidentKey(state), until: nowMs + HIDE_MS })
}

// Пояснение прямо в плашке (поручение Анны 02.11.2026: «чтобы понимали, что значит красное»).
export const LEGEND = [
  { tone: 'red', label: 'Красная', text: 'новые рейсы из TMS не попадают в ERP' },
  { tone: 'amber', label: 'Оранжевая', text: 'рейсы приходят, но отдельные рейсы не загрузились' },
]

export function meaning(state) {
  if (!state) return ''
  if (state.reason === 'stuck') {
    return state.state === 'down'
      ? 'Много рейсов есть в TMS, но не появились в ERP. Новые рейсы в целом приходят.'
      : 'Рейсы из TMS в целом приходят, но рейсы из списка ниже не загрузились.'
  }
  if (state.reason === 'queue') return 'Рейсы из TMS приходят с большой задержкой — новые заявки появляются в ERP не сразу.'
  return 'Новые рейсы из TMS сейчас не попадают в ERP. Уже загруженные рейсы работают как обычно.'
}

export function todo(state) {
  if (!state) return ''
  if (state.reason === 'stuck') {
    return 'Рейсы из списка ведите в TMS. Система продолжает загружать их сама — когда загрузятся, они пропадут из списка.'
  }
  return 'Новые заявки смотрите прямо в TMS. Ничего не теряется: когда связь восстановится, рейсы появятся в ERP сами, а плашка исчезнет.'
}

export const REASSURE = 'IT и руководители уже получили уведомление — писать им не нужно.'
